import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface GestorRouteProps {
  children: React.ReactNode;
}

/**
 * Guarda de rota: só permite acesso ao conteúdo se o usuário tiver o papel
 * `gestor_ouvidoria`. Caso contrário, redireciona para a Visão Geral.
 *
 * Enquanto a sessão ainda está carregando (`isLoading`), renderiza nada para
 * evitar um flicker de redirecionamento antes de saber se é gestor.
 */
// TODO: remover quando a checagem de gestor estiver integrada ao auth real.
// Enquanto true, qualquer usuário consegue acessar a página de Ouvidoria.
const DEV_BYPASS_GESTOR = true;

export function GestorRoute({ children }: GestorRouteProps) {
  const { isGestorOuvidoria, isLoading } = useAuth();

  if (DEV_BYPASS_GESTOR) return <>{children}</>;

  if (isLoading) return null;
  if (!isGestorOuvidoria()) return <Navigate to="/" replace />;
  return <>{children}</>;
}
